import { FC } from "preact/compat";
import { ActivityBoxProps } from "./interfaces";
import cn from "classnames";

const ActivityBox: FC<ActivityBoxProps> = ({ type, start, title }) => (
    <div>
        <div className={cn("d-activity-box", type)}>
            {start && <span className="mr-2">{start.substring(0, 5)}</span>}
            {title ?? "Activity"}
        </div>
    </div>
);

export default ActivityBox;
